import React from 'react'
import Skeleton from '@mui/material/Skeleton';

function PremiumPackageHomeSkeleton() {
  return (
    <>
    <div className='mt-6'> 
      <Skeleton variant='text' width={180} sx={{fontSize:24,marginBottom:2}} />
    </div>
    <div className="overflow-x-auto whitespace-no-wrap mb-8">
      <div className="flex">
        {[...Array(15)].map((x, index) => (<Skeleton variant='rounded' width={280} height={56} className='flex-none mr-4 overflow-hidden'/>))}
      </div>
    </div>
    </>
  )
}

export default PremiumPackageHomeSkeleton
